
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaching/[skill]",
      function () {
        return require("private-next-pages/coaching/[skill].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaching/[skill]"])
      });
    }
  